export const SavedAddressesListKeys = {
  mainTextKey: "customer_address_name",
  subTextKey: "formatted_address",
  itemIconKey: "customer_address_name",
  listTitle: "",
  editableIconClass: "hkfi-drag fs-16",
  listItemClass: "reusable-list-item-cart"
};

export const SearchPredictionsListKeys = {
  mainTextKey: "structuredFormatting.mainText",
  subTextKey: "structuredFormatting.secondaryText",
  commanItemIconClass: "hkfi-location-line fs-24 color-grey-light",
  listClassName: "ml16 mt4",
  listTitle: "",
};

export const RecentSearchListLength = 4;

export const RecentSearchListKeys = {
  mainTextKey: "structuredFormatting.mainText",
  subTextKey: "structuredFormatting.secondaryText",
  commanItemIconClass: "hkfi-recent fs-24 color-grey-light",
  listTitle: "Recent Searches",
  listTitleClass: "bold fs-14 mt24 mb3 list-label disp-col-inline jcsb",
  className: "recent-searches",
  titleRightButton:"Clear",
  titleRightButtonClass:"mr16 color-tertiary fs-12 lh16 bold",
};

export const ModifiedAddressIcons = {
  Home: {
    icon: "hkfi-home-line",
  },
  Office: {
    icon: "hkfi-office-v2",
  },
  Other: {
    icon: "hkfi-location-line",
  },
};
